module.exports = __webpack_public_path__ + "static/media/wrl-mid-ohio-logo@2x.0bb598a8.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-mid-ohio-logo@2x.png
// module id = 1216
// module chunks = 0